import { render, staticRenderFns } from "./StudentApartment.vue?vue&type=template&id=7c7ef9d9&scoped=true"
import script from "./StudentApartment.vue?vue&type=script&lang=js"
export * from "./StudentApartment.vue?vue&type=script&lang=js"
import style0 from "./StudentApartment.vue?vue&type=style&index=0&id=7c7ef9d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7ef9d9",
  null
  
)

export default component.exports